import { useMemo } from 'react';
import { formatOperationalHour, formatPhoneNumber, isEmptyData } from '../../../../utils/helper';
import HourTime from '../HourTime';
import { PhoneIcon } from '@heroicons/react/24/solid';
import { HalalIcon, MapPinIcon } from '../../../../utils/svg';
import ImageLoader from '../../ImageLoader';

const Info = (props) => {
	const { outlet } = props;

	const operational = useMemo(() => {
		if (isEmptyData(outlet?.operationalHour)) return [];
		return formatOperationalHour(outlet?.operationalHour);
	}, [outlet?.operationalHour]);

	const distance = parseFloat(outlet?.distance || 0)?.toFixed('2');

	const handleCall = (phone) => {
		if (isEmptyData(phone)) return;
		const cleanPhone = formatPhoneNumber(phone);
		if (cleanPhone) {
			window.location.href = `tel:${cleanPhone}`;
		}
	};

	const handleOpenMaps = (lat, lng) => {
		if (isEmptyData(lat) || isEmptyData(lng)) return;
		const latitude = parseFloat(lat);
		const longitude = parseFloat(lng);
		const googleMapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
		window.open(googleMapsUrl, '_blank');
	};

	return (
		<>
			<div className='m-4'>
				<div className='text-center font-semibold text-base text-gray-700 mb-4'>Outlet Info</div>
				<div className='border-t-1 border-solid border-gray-200' />
				<div className='flex items-center my-4'>
					<ImageLoader src={outlet?.storeImage} alt={outlet?.storeName} className='aspect-[1/1] w-11 h-auto object-fill rounded-full' />
					<div className='pl-4 space-y-2'>
						<div className='font-semibold text-base text-gray-700'>{outlet?.storeName}</div>
						<div className='flex items-center gap-1'>
							<HalalIcon />
							<div className='font-medium text-xxs text-gray-700'>{outlet?.restaurant_type || 'Indonesian Food'}</div>
						</div>
					</div>
				</div>
				<div className='flex mb-4 w-full justify-between gap-4'>
					<div className='flex flex-col gap-1'>
						<div className='font-semibold text-xs text-gray-700'>Address</div>
						<div className='font-normal text-xxs text-gray-600'>{outlet?.storeAddress}</div>
						<div className='font-semibold text-xxs text-gray-700'>{distance} km</div>
					</div>
					<div className='shadow-custom rounded-lg flex justify-center items-center py-2 px-1.5 w-full max-w-[4.5rem] h-full min-h-[4.5rem]' onClick={() => handleCall(outlet?.outlet_phone)}>
						<div className='flex flex-col items-center gap-1'>
							<div className='rounded-full p-2 w-7 bg-[var(--rose-violet-opacity)]'>
								<PhoneIcon className='text-[var(--rose-violet)]' />
							</div>
							<div className='text-xxs font-normal text-gray-600'>Contact us</div>
						</div>
					</div>
					<div className='shadow-custom rounded-lg flex justify-center items-center py-2 px-1.5 w-full max-w-[4.5rem] h-full min-h-[4.5rem]' onClick={() => handleOpenMaps(outlet?.outlet_marker_latitude, outlet?.outlet_marker_longitude)}>
						<div className='flex flex-col items-center gap-1'>
							<div className='rounded-full bg-[var(--rose-violet-opacity)]'>
								<MapPinIcon className='text-[var(--rose-violet)]' />
							</div>
							<div className='text-xxs font-normal text-gray-600'>Visit us</div>
						</div>
					</div>
				</div>
				<div className='font-semibold text-xs text-gray-700 mb-2'>Operational Hours</div>
				<HourTime {...{ operational }} />
			</div>
		</>
	);
};

export default Info;
